import InfoIcon from "imagesUwKluis/svg/info.svg";
import { useState } from "react";
import { Box } from "../../shared/layouts";
import Table from "../../shared/Table";
import { formatISODate } from "../../../utils/dateHelpers";
import Modal from "../../shared/Modal";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";

const HighlightIcon = styled('div')(({ theme }) => ({
  display: 'inline-block',
  width: '12px',
  height: '12px',
  marginLeft: '8px',
  borderRadius: '50%',
  backgroundColor: theme?.colors?.primary,
}));

const initialState = {
  sortBy: [{ id: "date", desc: true }],
};

const FilesTable = ({data, isError}) => {
  const { t } = useTranslation();

  const columns = [
    {
      Header: t("naam"),
      accessor: "name",
      width: 150,
      Cell: ({ row: { original: { name, highlighted } } }) => (
        <>
          <span>{name}</span>
          {highlighted && <HighlightIcon />}
        </>
      )
    },
    {
      Header: '',
      width: 16,
      sortable: false,
      accessor: 'description',
      Cell: ({ row: { original: { name, description } } }) => {
        const [showDescription, setShowDescription] = useState(false);
        return description ? (
          <div title={description}>
            <InfoIcon
              width="1rem"
              height="1rem"
              css={(theme) => ({
                fill: theme?.colors?.primary,
                cursor: 'pointer',
              })}
              onClick={() => setShowDescription(true)}
            />
            <Modal
              isOpen={showDescription}
              onRequestClose={() => setShowDescription(false)}
            >
              <Box
                fontScale="xl"
                fontWeight="bold"
                margin="16px 0"
                textAlign="center"
              >
                {name}
              </Box>
              <Box textAlign="center">{description}</Box>
            </Modal>
          </div>
        ) : null;
      },
    },
    {
      Header: t("datum"),
      accessor: "date",
      width: 50,
      Cell: ({ value }) => formatISODate(value),
    },
    {
      accessor: t("download"),
      width: 25,
      align: "right",
    },
  ];

  return (
    <>
      {data && <Table {...{ data, columns, initialState }} />}
      {(!data?.length || isError) && (
        <Box width="100%" color="secondaryFont" textAlign="center">
          {isError
            ? t("Er kunnen geen gedeelde documenten opgehaald worden")
            : t("Er zijn geen gedeelde documenten")}
        </Box>
      )}
    </>
  );
};

export default FilesTable;
